import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CTAButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'outline';
  href?: string;
  className?: string;
};
export function CTAButton({
  children,
  size = 'md',
  variant = 'primary',
  href = '#oferta',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'lg' ? 'text-base sm:text-lg px-8 py-4 sm:px-10 sm:py-5' : 'text-sm sm:text-base px-6 py-3.5';
  const variantClasses = variant === 'primary' ? 'bg-clay-500 text-white hover:bg-clay-600 shadow-lg shadow-clay-500/25' : 'bg-white text-forest-700 border border-forest-100 hover:border-forest-400 hover:text-forest-800';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-tight transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-clay-500 focus-visible:ring-offset-2 focus-visible:ring-offset-sand-100 ${sizeClasses} ${variantClasses} ${className}`} data-id="element-213" data-mp="2xaz22nqbqvw3">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" data-id="element-214" data-mp="ah5800zd53tp" />
    </a>;
}